import type { Face } from './face-kit';
import {
  arnaqueur,
  collant,
  desagreable,
  intolerant,
  maleAlpha,
  meprisant,
  random,
} from './faces-1';
import { FULL_FACES } from './full';
import { bavard, fatigue, filmeur, neutral, zombie } from './faces-2';
import { batterieAPlat, batterieAPlatGlad, couvreFeu, couvreFeuGlad } from './faces-bosses';
import { POGO_FACE } from './pogo-face';
import { COUP_DE_VENT_FACE } from './vent-face';

export { FACE_RADIUS, NEUTRAL, cracks, type Face, type Pose } from './face-kit';
export { drowsyZ, recruit, smile } from './faces-2';

const MAIN = { boss: false, loopBeats: 1 };

export const NEUTRAL_FACE: Face = { ...MAIN, draw: neutral, frames: 1 };

// A test holds this list to the ids of src/data/enemies.ts; the full game's are in `FULL_FACES`.
export const FACES: Readonly<Record<string, Face>> = {
  random: { ...MAIN, draw: random, frames: 4, loopBeats: 4 },
  desagreable: { ...MAIN, draw: desagreable, frames: 1 },
  meprisant: { ...MAIN, draw: meprisant, frames: 1 },
  'male-alpha': { ...MAIN, draw: maleAlpha, frames: 1 },
  collant: { ...MAIN, draw: collant, frames: 4 },
  intolerant: { ...MAIN, draw: intolerant, frames: 4 },
  arnaqueur: { ...MAIN, draw: arnaqueur, frames: 1 },
  fatigue: { ...MAIN, draw: fatigue, frames: 4, loopBeats: 4, drowsy: true },
  filmeur: { ...MAIN, draw: filmeur, frames: 4 },
  bavard: { ...MAIN, draw: bavard, frames: 4 },
  zombie: {
    ...MAIN,
    draw: zombie,
    frames: 4,
    loopBeats: 2,
    tone: { token: 'healer', amount: 0.14 },
  },
  'couvre-feu': {
    ...MAIN,
    draw: couvreFeu,
    glad: couvreFeuGlad,
    frames: 16,
    loopBeats: 4,
    boss: true,
  },
  'batterie-a-plat': {
    ...MAIN,
    draw: batterieAPlat,
    glad: batterieAPlatGlad,
    frames: 16,
    loopBeats: 4,
    boss: true,
  },
  'coup-de-vent': COUP_DE_VENT_FACE,
  pogo: POGO_FACE,
  ...FULL_FACES,
};

export const warnUnknown = (message: string): void => {
  if (import.meta.env.DEV) {
    console.warn(message);
  }
};

// Never an error: the content may be ahead of the drawings.
export function picker<T>(
  items: ReadonlyMap<string, T>,
  fallback: T,
  warn: (message: string) => void,
): (kind: string) => T {
  const warned = new Set<string>();
  return (kind) => {
    const found = items.get(kind);
    if (found !== undefined) {
      return found;
    }
    if (!warned.has(kind)) {
      warned.add(kind);
      warn(`No mask for the bad vibe "${kind}", drawing a neutral one`);
    }
    return fallback;
  };
}
